<script setup lang="ts">
import type { Employee } from 'types/blocks';

const layout = useLayout();

defineProps<{
  employeeData: Employee;
  imagePortrait: boolean;
}>();
</script>

<template>
  <article class="relative flex flex-col">
    <figure
      v-if="employeeData.image?.url"
      class="mb-2 w-full overflow-clip lg:mb-4"
    >
      <BaseImage
        class="w-full"
        :class="{ 'rounded-full': imagePortrait }"
        :image="employeeData.image"
        format="webp"
        :width="layout.isDesktop ? 408 : 272"
        :height="layout.isDesktop ? 611 : 408"
      />
    </figure>

    <div
      v-if="employeeData"
      class="flex flex-col items-center text-center text-base"
    >
      <span
        v-if="employeeData.title"
        class="text-xs lg:text-base"
        >{{ employeeData.title }}</span
      >
      <h4
        v-if="employeeData.name"
        class="mb-2 text-center text-sm font-bold lg:mb-3 lg:text-h4"
      >
        {{ employeeData.name }}
      </h4>

      <BaseLink
        v-if="employeeData.email"
        :to="`mailto:${employeeData.email}`"
        class="mb-1 text-center text-xs underline opacity-75 lg:text-sm"
      >
        {{ employeeData.email }}
      </BaseLink>

      <BaseLink
        v-if="employeeData.phone"
        :to="`tel:${employeeData.phone}`"
        class="text-center text-xs underline opacity-75 lg:text-sm"
      >
        {{ employeeData.phone }}
      </BaseLink>
    </div>
  </article>
</template>
